module.exports = __webpack_public_path__ + "static/media/oniku.144559eb.cur";


//////////////////
// WEBPACK FOOTER
// ./src/asset/oniku.cur
// module id = 782
// module chunks = 0